import type { ITrainingRecord, IPRRecord } from "@/hooks/useAppState";

/** Reconstruct breakthroughs from actual completed sets up to the requested week. */
export function trainingPRsInRange(
  records: ITrainingRecord[],
  start: string,
  end: string,
): IPRRecord[] {
  const best = new Map<string, IPRRecord>();
  const weekly = new Map<string, IPRRecord>();
  const ordered = [...records]
    .filter((r) => r.date <= end)
    .sort((a, b) => a.date.localeCompare(b.date) || a.id.localeCompare(b.id));
  for (const record of ordered)
    for (const exercise of record.exercises) {
      let candidate = best.get(exercise.exerciseId);
      for (const set of exercise.sets) {
        if (!set.completed || set.reps <= 0) continue;
        if (
          !candidate ||
          set.weight > candidate.maxWeight ||
          (set.weight === candidate.maxWeight && set.reps > candidate.maxReps)
        ) {
          candidate = {
            exerciseId: exercise.exerciseId,
            exerciseName: exercise.exerciseName,
            maxWeight: set.weight,
            maxReps: set.reps,
            recordDate: record.date,
            recordId: record.id,
          };
        }
      }
      if (candidate && candidate !== best.get(exercise.exerciseId)) {
        best.set(exercise.exerciseId, candidate);
        if (record.date >= start) weekly.set(exercise.exerciseId, candidate);
      }
    }
  return [...weekly.values()].sort((a, b) =>
    a.recordDate.localeCompare(b.recordDate),
  );
}

export function reducedExerciseSets(
  count: number,
  reductionPercent: number,
): number {
  return count > 1 && reductionPercent > 0
    ? Math.max(
        1,
        count - Math.max(1, Math.round((count * reductionPercent) / 100)),
      )
    : count;
}
